import { getApp } from '@/utils/starters';
import { MCA } from '@/utils/constants';
import getUrlParams from '@/utils/getUrlParams';

const mcaRedirectorMiddleware = (to, from, next) => {
  const app = getApp();
  const isMCA = app === MCA;

  if (!isMCA) {
    next();
    return;
  }

  const fromRedirector = from.name === 'MCARedirector';
  const toSetNumber = to.name === 'SetNumber';
  if (toSetNumber && !fromRedirector) {
    const t = getUrlParams('t');

    next({
      name: 'MCARedirector',
      query: { t, app }
    });
    return;
  }

  next();
};

export default mcaRedirectorMiddleware;
